import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-2 pb-2 text-left" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "mt-1" }
const _hoisted_10 = { class: "inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_11 = { class: "block truncate" }
const _hoisted_12 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_13 = { class: "mt-2 pb-2 text-left" }
const _hoisted_14 = { class: "text-sm" }
const _hoisted_15 = { class: "mt-1" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "mt-2 pb-2 text-left" }
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "mt-2 pb-2 text-left" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "mt-1" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }

import { computed, inject, ref, onMounted } from "vue";
import { AxiosInstance } from "axios";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { useStore } from "vuex";

import { translate } from "@/utils/tools";

export default /*#__PURE__*/_defineComponent({
  __name: 'TierConfigDialog',
  props: { form: Object, show: Boolean },
  emits: ["topup", "update:show", "update:form", "update"],
  setup(__props, { emit }) {

const props = __props

const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
onMounted(async () => {
  advanceFromOption.value = await paymentGateway();
});
let selectedOption = ref({ label: `-${translate("messages.withdrawTransaction.selected")}-`, value: null });

const paymentGateway = async ()=>{
  let payload = {
    operatorId: store.state.selectedOperator.operatorId,
    useWithdraw:true
  }
  try {
    const { data } = await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/operator-payment-gateway/operator`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log(data)
    return data.map((payment:any) => ({
      label: payment.paymentName,
      value: payment.paymentId,
    }));
  } catch (error) {
    console.error("Error fetching payment gateways:", error);
    return [];
  }
};

let advanceFromOption = ref([]);

const configDetail = ref({
  paymentName:'',
  minAmount: 0,
  maxAmount: 0,
  feeAmount: 0,
});
const createTier = async () => {
  try {
  await axios.post(
    `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/tier-config/create`,
    {
      operatorId: store.state.selectedOperator.operatorId,
      paymentId: selectedOption.value.value,
      minAmount:Math.round(Number(configDetail.value.minAmount)*100 ),
      maxAmount: Math.round(Number(configDetail.value.maxAmount)*100),
      feeAmount: Math.round(Number(configDetail.value.feeAmount)*100)
    }
  );
  emit("update");
  showSync.value = false;
} catch (error) {
  alert('Create Failed')
}
};

const onlyNumber = (event: KeyboardEvent) => {
  const invalidChars = ["e", "E", "+", "-", "*", "/"];
  if (invalidChars.includes(event.key)) {
    event.preventDefault();
  }
};



return (_ctx: any,_cache: any) => {
  const _component_SelectorIcon = _resolveComponent("SelectorIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!

  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[6] || (_cache[6] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.tierConfig.createNewTierConfig")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.tierConfig.paymentName")), 1),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(Listbox), {
                              modelValue: _unref(selectedOption),
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedOption) ? (selectedOption).value = $event : selectedOption = $event))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_unref(ListboxButton), { class: "w-full py-2 pl-3 text-left bg-white rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_10, [
                                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(selectedOption).label), 1),
                                        _createVNode(_component_SelectorIcon, {
                                          class: "w-5 h-5 text-gray-400 ml-auto",
                                          "aria-hidden": "true"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_Transition, {
                                    "leave-active-class": "transition duration-100 ease-in",
                                    "leave-from-class": "opacity-100",
                                    "leave-to-class": "opacity-0"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ListboxOptions), { class: "absolute w-10/12 max-h-60 mt-1 mx-2 py-1 z-100 bg-white shadow-lg rounded-md text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(advanceFromOption), (option, index) => {
                                            return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                              key: index,
                                              value: option,
                                              as: "template"
                                            }, {
                                              default: _withCtx(({ active, selected }) => [
                                                _createElementVNode("li", {
                                                  class: _normalizeClass([
                                      active
                                        ? 'text-amber-900 bg-amber-100'
                                        : 'text-gray-900',
                                      'cursor-default select-none relative py-2 pl-10 pr-4',
                                    ])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass([
                                        selected ? 'font-medium' : 'font-normal',
                                        'block truncate',
                                      ])
                                                  }, _toDisplayString(option.label), 3),
                                                  selected
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                        _createVNode(_component_CheckIcon, {
                                                          class: "w-5 h-5",
                                                          "aria-hidden": "true"
                                                        })
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 2)
                                              ]),
                                              _: 2
                                            }, 1032, ["value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("messages.tierConfig.minAmount")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((configDetail.value.minAmount) = $event)),
                            name: "minAmount",
                            id: "minAmount",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            placeholder: _ctx.$t('messages.tierConfig.minAmount'),
                            required: "",
                            onKeypress: onlyNumber
                          }, null, 40, _hoisted_16), [
                            [_vModelText, configDetail.value.minAmount]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("messages.tierConfig.maxAmount")), 1),
                        _createElementVNode("div", _hoisted_19, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((configDetail.value.maxAmount) = $event)),
                            name: "maxAmount",
                            id: "maxAmount",
                            step: "1",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            onKeypress: onlyNumber,
                            placeholder: _ctx.$t('messages.tierConfig.maxAmount'),
                            require: ""
                          }, null, 40, _hoisted_20), [
                            [_vModelText, configDetail.value.maxAmount]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("messages.tierConfig.feeAmount")), 1),
                        _createElementVNode("div", _hoisted_23, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((configDetail.value.feeAmount) = $event)),
                            name: "feeAmount",
                            step: "0.01",
                            id: "feeAmount",
                            class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md",
                            placeholder: _ctx.$t('messages.tierConfig.feeAmount')
                          }, null, 8, _hoisted_24), [
                            [_vModelText, configDetail.value.feeAmount]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (createTier()))
                    }, _toDisplayString(_ctx.$t("messages.tierConfig.createTierConfig")), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showSync.value = false)),
                      class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, _toDisplayString(_ctx.$t("messages.tierConfig.cancel")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})